import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {OperationCard} from "../../model/OperationCard";
import {KpiService} from "../../services/KpiService";
import {LogaFieldTeamActivityReport} from "../../model/kpi-data";

/**
 * Generated class for the FieldTeamActivityReportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-field-team-activity-report',
  templateUrl: 'field-team-activity-report.html',
})
export class FieldTeamActivityReportPage {

  uiloading: boolean;

  /**
   * simple operation name to display on top of page
   */
  private uiOperationName: string;

  /**
   * operation card, with basic identity information
   */
  private uiOpCard: OperationCard;
  /**
   * loaded report from the KPI Api
   */
  private report: LogaFieldTeamActivityReport;

  constructor(public navCtrl: NavController, public navParams: NavParams, private kpiService: KpiService) {
    let operation: OperationCard = this.navParams.get('operationCard');
    this.uiOperationName = operation.name;
    this.uiOpCard = operation;
  }

  ionViewWillEnter() {
    this.uiloading = true;
  }

  ionViewDidLoad() {
    console.log({page: 'FiedTeamActivityReportPage.ionViewDidLoad'});

    this.kpiService.loadFieldTeamActivityReport(this.uiOpCard.id).then(report => {
      console.log({page: 'FiedTeamActivityReportPage.kpiLoaded', report: report});
      this.uiloading = false;
      this.report = report;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/field-team-activity-report/field-team-activity-report.ts